var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60146",
    "data-name": "Group 60146",
    transform: "translate(8886 -12612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16338",
    "data-name": "Rectangle 16338",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(-8886 12612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_9adebc0301c090e5172ffd750c77035c",
    "data-name": "9adebc0301c090e5172ffd750c77035c",
    transform: "translate(-8865.291 12633.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17231",
    "data-name": "Path 17231",
    d: "M49.958,2,27.88,18.4l4.083-9.674Z",
    transform: "translate(4.805)",
    fill: "#e2761b",
    stroke: "#e2761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17232",
    "data-name": "Path 17232",
    d: "M3.725,2l21.9,16.553-3.883-9.83ZM46.749,40.009l-5.88,9.009L53.45,52.479l3.617-12.27Zm-45.354.2L4.99,52.479l12.581-3.461-5.88-9.009Z",
    transform: "translate(0.071)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17233",
    "data-name": "Path 17233",
    d: "M15.047,22.5l-3.506,5.3,12.492.555L23.59,14.937Zm24.7,0-8.654-7.722L30.8,28.361l12.47-.555ZM15.757,46.733l7.5-3.661-6.479-5.059Zm15.776-3.661,7.522,3.661-1.043-8.72Z",
    transform: "translate(1.884 2.285)",
    fill: "#e4761b",
    stroke: "#e4761b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17234",
    "data-name": "Path 17234",
    d: "M38.416,42.442l-7.522-3.661.6,4.9-.067,2.064Zm-23.3,0,6.99,3.306-.044-2.063.555-4.9Z",
    transform: "translate(2.524 6.576)",
    fill: "#d7c1b3",
    stroke: "#d7c1b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17235",
    "data-name": "Path 17235",
    d: "M22.09,32.327l-6.257-1.842,4.416-2.019Zm9.075,0,1.842-3.861,4.438,2.019Z",
    transform: "translate(2.652 4.731)",
    fill: "#161616",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17236",
    "data-name": "Path 17236",
    d: "M16.009,44.758l1.065-9.009-6.945.2Zm22.233-9.009,1.065,9.009,5.88-8.809Zm5.281-9.918-12.47.555L32.207,32.8l1.842-3.861,4.438,2.019ZM16.853,30.956l4.438-2.019L23.11,32.8l1.176-6.413-12.492-.555Z",
    transform: "translate(1.632 4.26)",
    fill: "#cd6116",
    stroke: "#cd6116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17237",
    "data-name": "Path 17237",
    d: "M11.541,25.831l5.236,10.207L16.6,30.956Zm26.693,5.126-.222,5.081,5.259-10.207Zm-14.2-4.571L22.857,32.8l1.464,7.566.333-9.963Zm6.768,0-.6,3.994.266,9.985L31.955,32.8Z",
    transform: "translate(1.884 4.26)",
    fill: "#e4751f",
    stroke: "#e4751f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17238",
    "data-name": "Path 17238",
    d: "M31.188,32.021,29.7,39.587l1.065.732,6.479-5.059.222-5.081ZM15.833,30.179l.178,5.081,6.479,5.059,1.065-.732L22.09,32.021Z",
    transform: "translate(2.652 5.038)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17239",
    "data-name": "Path 17239",
    d: "M31.426,45.193l.067-2.064-.555-.488H22.573l-.51.488.044,2.064-6.99-3.306,2.441,2,4.948,3.439H31l4.97-3.439,2.441-2Z",
    transform: "translate(2.524 7.131)",
    fill: "#c0ad9e",
    stroke: "#c0ad9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17240",
    "data-name": "Path 17240",
    d: "M29.841,38.892l-1.065-.732H22.629l-1.065.732-.555,4.9.51-.488h8.365l.555.488Z",
    transform: "translate(3.577 6.464)",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17241",
    "data-name": "Path 17241",
    d: "M55.7,19.462l1.886-9.053L54.763,2,33.418,17.843l8.21,6.945,11.6,3.395,2.574-3-1.109-.8,1.775-1.62L55.1,21.7l1.775-1.353ZM1,10.41l1.886,9.053-1.2.888L3.463,21.7,2.109,22.769l1.775,1.62-1.109.8,2.552,3,11.6-3.395,8.21-6.945L3.8,2Z",
    fill: "#763d16",
    stroke: "#763d16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17242",
    "data-name": "Path 17242",
    d: "M53.162,27.163l-11.6-3.395,3.528,5.3L39.826,39.278l6.923-.089H57.067Zm-36.3-3.395-11.6,3.395L1.4,39.189h10.3l6.9.089L13.355,29.071Zm15.754,5.858.732-12.8L36.72,7.7H21.742l3.328,9.12.777,12.8.266,4.038.022,9.941h6.146l.044-9.941Z",
    transform: "translate(0.071 1.02)",
    fill: "#f6851b",
    stroke: "#f6851b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.9b643427c2d207b787f6b6af8c88535e.svg";
export { ForwardRef as ReactComponent };